import React from "react";

function SectionHeader({ icon, iconTone = "purple", title, subtitle, extra }) {
  return (
    <div className="hr-dashboard__card-header">
      <div className="hr-dashboard__card-header-main">
        <span className={`hr-dashboard__card-icon hr-dashboard__card-icon--${iconTone}`}>
          {icon}
        </span>
        <div>
          <h2 className="hr-dashboard__section-title">{title}</h2>
          {subtitle && (
            <p className="hr-dashboard__section-subtitle">{subtitle}</p>
          )}
        </div>
      </div>
      {extra}
    </div>
  );
}

export default SectionHeader;
